import React from 'react';
import styled from '../../styled';
import { DemoButton } from '../DemoButton';

const ColumnWrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 40px;
  row-gap: 100px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const SectionWrapper = styled('section')`
  padding: 40px 24px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 960px) {
    padding: 80px 24px;
  }
`;

const Quote = styled('blockquote')`
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5;
  color: #0e1c2b;
  margin: 0 0 40px 0;
  font-style: italic;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 960px) {
    font-size: 22px;
    height: auto;
  }

  @media (max-width: 600px) {
    font-size: 18px;
    height: auto;
  }
`;

const QuoteText = styled('div')``;

const AuthorWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`;

const LogoImage = styled('img')`
  width: auto;
  height: 50px;
  opacity: 0.8;
  transition: opacity 0.2s, filter 0.2s;
  margin-bottom: 20px;

  &:hover {
    opacity: 1;
    filter: grayscale(0%);
  }
`;

const AuthorInfo = styled('div')`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 4px;
`;

const AuthorName = styled('div')`
  font-size: 16px;
  font-weight: 600;
  color: #0e1c2b;
`;

const AuthorTitle = styled('div')`
  font-size: 14px;
  color: #4f4f4f;
`;

export const TestimonialSection = () => {
  return (
    <SectionWrapper>
      <ColumnWrapper>
        <div>
          <LogoImage src="/images/logos/usa-today.svg" alt="USA Today" />
          <Quote>
            <QuoteText>
              "The level of detail we can see now is a total game-changer. We're
              able to make smarter, faster decisions, and it's showing up in the
              revenue."
            </QuoteText>
          </Quote>
          <AuthorWrapper>
            <AuthorInfo>
              <AuthorName>Jim Ryan</AuthorName>
              <AuthorTitle>
                Sr Director of Affiliate Strategy, Commerce Content
              </AuthorTitle>
            </AuthorInfo>
          </AuthorWrapper>
        </div>
        <div>
          <LogoImage src="/images/logos/people-inc.svg" alt="People Inc." />
          <Quote>
            <QuoteText>
              "Affilimate's features and insights have been invaluable as we
              navigate the changing commerce landscape. And the incredible
              support is a cherry on top."
            </QuoteText>
          </Quote>
          <AuthorWrapper>
            <AuthorInfo>
              <AuthorName>Jose Ramirez</AuthorName>
              <AuthorTitle>SVP, Commerce Business Strategy</AuthorTitle>
            </AuthorInfo>
          </AuthorWrapper>
        </div>
        <div>
          <LogoImage
            src="/images/logos/everyday-health-group.png"
            alt="Everyday Health Group"
          />
          <Quote>
            <QuoteText>
              "Affilimate delivers exceptional offsite tracking in a platform
              our teams actually use. It's deeply granular but simple to use,
              interpret, and drive material revenue from. Without tying up
              engineering resources."
            </QuoteText>
          </Quote>
          <AuthorWrapper>
            <AuthorInfo>
              <AuthorName>Samantha Baker</AuthorName>
              <AuthorTitle>Group VP, Everyday Health Group</AuthorTitle>
            </AuthorInfo>
          </AuthorWrapper>
        </div>
      </ColumnWrapper>
      <br />
      <br />
      <DemoButton text="Get a demo" variant="contained" />
    </SectionWrapper>
  );
};
